import { callFunctionIfExists } from "utils/GeneralUtils";
import StrUtils from "utils/StrUtils";
import { useState } from "react";
import CreateQuickCreateDrawer from "../Drawers/CreateQuickCreateDrawer/CreateQuickCreateDrawer";
import useToggle from "../../hooks/useToggle";
import ManageItems from "../ManageItems/ManageItems";

const SubModulePrefill = ({
  module,
  prefills,
  onUpdate,
  onDelete,
  onReorder,
}) => {
  const [prefillDrawer, togglePrefillDrawer] = useToggle();
  const [editPrefill, setEditPrefill] = useState(null);

  const createPrefill = ({ key, payload, onSuccess }) => {
    const newPrefill = {
      ModuleAPIName: payload.ModuleAPIName,
      Name: payload.Name,
      id: StrUtils.uuidv4(),
      PrefillPairs: payload.PrefillPairs,
      Icon: payload.Icon,
    };

    onUpdate([...prefills, newPrefill]);
    callFunctionIfExists(onSuccess);
  };

  const updatePrefill = ({ id, key, payload, onSuccess }) => {
    const newPrefills = prefills.map((p) => {
      if (p.id === id) {
        return {
          ModuleAPIName: payload.ModuleAPIName,
          Name: payload.Name,
          id: id,
          PrefillPairs: payload.PrefillPairs,
          Icon: payload.Icon,
        };
      }
      return p;
    });

    onUpdate(newPrefills);
    callFunctionIfExists(onSuccess);
  };

  return (
    <>
      {module && (
        <ManageItems
          onUpdate={onUpdate}
          onDelete={onDelete}
          onReorder={onReorder}
          onEdit={(val) => {
            setEditPrefill(val);
            togglePrefillDrawer();
          }}
          allowAdd={true}
          onAdd={togglePrefillDrawer}
          items={prefills}
        />
      )}
      <CreateQuickCreateDrawer
        variableIdentifiers={["user", "record"]}
        open={prefillDrawer}
        onClose={() => {
          togglePrefillDrawer();
          setEditPrefill(null);
        }}
        onCreate={createPrefill}
        onUpdate={updatePrefill}
        afterCreate={togglePrefillDrawer}
        afterUpdate={() => {
          setEditPrefill(null);
          togglePrefillDrawer();
        }}
        moduleAPIName={module?.APIName}
        existingQuickCreate={editPrefill}
        recordModuleAPIName={module?.APIName}
        updating={false}
      />
    </>
  );
};

export default SubModulePrefill;
